import {RouterView} from '@/routes/RouterView.js';
const Company = _ => import(
	/* webpackChunkName: "js/split/Company", webpackPreload: true */
	'@/components/views/home/advisor/company/partials/Company');


export default {
	path: '/empresa/',
	component: RouterView,
	children: [
		{
			path: 'index',
			component:  Company,
			name: 'Company',
			meta:{
				auth: true
			}
		},
	],

}
